export const SHOW_PARAMS = [  "factor" ];


// WEBPACK FOOTER //
// ./src/scenes/PayoutFactorAll/config.js